const MEMBER_COLORS = {
  slate: '#64748b', rose: '#f43f5e', amber: '#f59e0b', emerald: '#10b981',
  sky: '#0ea5e9', violet: '#8b5cf6', pink: '#ec4899', orange: '#f97316',
  teal: '#14b8a6', indigo: '#6366f1',
}

function timeAgo(isoStr) {
  const diff = Date.now() - new Date(isoStr).getTime()
  const mins  = Math.floor(diff / 60000)
  const hours = Math.floor(diff / 3600000)
  const days  = Math.floor(diff / 86400000)
  if (mins < 1)   return 'just now'
  if (mins < 60)  return `${mins}m ago`
  if (hours < 24) return `${hours}h ago`
  return `${days}d ago`
}

export function FamilyFeedPanel({ data }) {
  const posts = data?.wallPosts ?? []

  if (posts.length === 0) {
    return (
      <div className="flex flex-col h-full items-center justify-center panel-animate-in px-4">
        <div className="text-5xl mb-3">📋</div>
        <p className="text-gray-400 text-lg text-center">No posts yet</p>
        <p className="text-gray-600 text-sm mt-1 text-center">Family posts will appear here</p>
      </div>
    )
  }

  const visible = posts.slice(0, 3)

  return (
    <div className="flex flex-col h-full px-4 sm:px-8 py-4 sm:py-6 panel-animate-in">
      <p className="text-gray-500 text-xs sm:text-sm font-semibold uppercase tracking-widest mb-4">Family Feed</p>

      <div className="flex-1 flex flex-col gap-3 min-h-0 overflow-hidden justify-center">
        {visible.map((post) => {
          const color = MEMBER_COLORS[post.authorColor] ?? '#8b5cf6'
          return (
            <div key={post.id} className="bg-white/5 rounded-2xl p-4 flex gap-3">
              {/* Avatar */}
              <div
                className="w-9 h-9 rounded-full flex-shrink-0 flex items-center justify-center text-white text-sm font-bold"
                style={{ backgroundColor: color }}
              >
                {post.authorName?.[0]?.toUpperCase() ?? '?'}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-baseline gap-2">
                  <span className="text-white text-sm font-semibold">{post.authorName}</span>
                  <span className="text-gray-600 text-xs">{timeAgo(post.created_at)}</span>
                </div>
                <p className="text-gray-300 text-sm sm:text-base mt-0.5 line-clamp-3">{post.body}</p>
              </div>

              {/* Photo thumbnail */}
              {post.photo_url && (
                <img
                  src={post.photo_url}
                  alt=""
                  className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl object-cover flex-shrink-0"
                />
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
